import { useState, useEffect } from "react";
import axios8200 from "../services/axios8200"; // Ensure this path matches your project structure

const UpdateMeddiccModal = ({ opportunityId, userId, apiKey, stage, onClose }) => {
  const [meddiccData, setMeddiccData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Function to fetch MEDDICC data from the backend
  const fetchMeddiccData = async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await axios8200.post(
        "/fetch_meddicc/?use_advanced_extraction=true",
        {
          user_id: userId,
          api_key: apiKey,
          opportunity_id: opportunityId,
          stage: stage || "Sales Stage 1 Discovery", // Use default if stage is not provided
        }
      );

      setMeddiccData(response.data); // Update state with fetched data
    } catch (err) {
      console.error("Error fetching MEDDICC data:", err);
      setError("Failed to fetch MEDDICC data. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  // Fetch MEDDICC data when the modal is opened
  useEffect(() => {
    fetchMeddiccData();
  }, []); // Empty dependency array ensures it runs only on mount

  return (
    <div className="modal">
      <div className="modal-content">
        <h3>Update MEDDICC</h3>

        {/* Display loading state */}
        {loading && <p>Loading MEDDICC data...</p>}

        {/* Display error state */}
        {error && <p className="error-message">{error}</p>}

        {/* Display fetched MEDDICC data */}
        {meddiccData && (
          <div>
            <h4>MEDDICC Scores</h4>
            <ul>
              {Object.entries(meddiccData.meddicc_scores || {}).map(([key, value]) => (
                <li key={key}>
                  <strong>{key}:</strong> {value}
                </li>
              ))}
            </ul>

            <h4>Compliance Score</h4>
            <p>{meddiccData.compliance_score}%</p>

            <h4>Closing Probability</h4>
            <p>{(meddiccData.closing_probability * 100).toFixed(2)}%</p>

            <h4>Next Steps</h4>
            {Object.entries(meddiccData.next_steps || {}).map(([role, steps]) => (
              <div key={role}>
                <h5>{role}</h5>
                <ul>
                  {steps.map((step, index) => (
                    <li key={index}>{step}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        )}

        <button onClick={onClose} className="close-button">
          Close
        </button>
      </div>
    </div>
  );
};

export default UpdateMeddiccModal;
